import { render, staticRenderFns } from "./Hazards.vue?vue&type=template&id=33a6214f&"
import script from "./Hazards.vue?vue&type=script&lang=js&"
export * from "./Hazards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports